'use strict';

const { snakeCase } = require('lodash');

var reqwest = require('reqwest');

module.exports = {
  /**
   * Method will add class to specified element
   *
   * @param {Element} element
   * @param {string} newClass
   */
  addClass: function (element, newClass) {
    var existingClasses = element.className.split(' ');

    if (existingClasses.indexOf(newClass) === -1) {
      existingClasses[existingClasses.length] = newClass;
    }

    element.className = existingClasses.join(' ');
  },

  /**
   * Method will remove class fromt the specified element
   *
   * @param {Element} element
   * @param {string} obsoleteClass
   */
  removeClass: function (element, obsoleteClass) {
    var existingClasses = element.className.split(' ');
    var position = existingClasses.indexOf(obsoleteClass);

    if (position !== -1) {
      delete existingClasses[position];
    }

    element.className = existingClasses.join(' ');
  },

  /**
   * Method will hide specified element
   *
   * @param {Element} element
   */
  hide: function (element) {
    element.style.display = 'none';
  },

  /**
   * Method will show specified element
   *
   * @param {Element} element
   */
  show: function (element) {
    element.style.display = 'block';
  },

  /**
   * Method will attache event to specified element
   *
   * @param {Element} element
   * @param {string} event
   * @param {Function} callback
   */
  addEvent: function (element, event, callback) {
    if (!element) {
      return;
    }
    if (element.addEventListener) {
      element.addEventListener(event, callback, false);
    } else {
      element.attachEvent(event, callback);
    }
  },

  addEventBySelector: function (selector, event, callback) {
    var elements = document.querySelectorAll(selector);
    var that = this;
    [].forEach.call(elements, function () {
      that.addEvent(arguments[0], event, callback);
    });
  },

  /**
   * Append option to specified select
   *
   * @param {Element} element
   * @param {string} value
   * @param {string} text
   */
  appendOption: function (element, value, text) {
    var option = document.createElement('option');
    option.value = value;
    option.innerHTML = text;
    //option.setAttribute("selected", "true");
    element.appendChild(option);
  },

  /**
   * Method for do ajax calls
   *
   * @param {string} url
   * @param {string} method - like GET or POST
   * @param {Function} onSuccessCallback
   * @param {string} [contentType="application/json"]
   * @param {boolean} [isCrossOriginRequest=true]
   * @param {Function} onFailureCallback, optional
   * @param {object} a map of custom headers, optional
   */
  ajax: function (
    url,
    method,
    onSuccessCallback,
    contentType,
    isCrossOriginRequest,
    onFailureCallback,
    headers
  ) {
    if (typeof contentType === 'undefined') {
      contentType = 'application/json';
    }

    if (typeof isCrossOriginRequest === 'undefined') {
      isCrossOriginRequest = true;
    }

    reqwest({
      url: url,
      type: 'json',
      method: method,
      success: onSuccessCallback,
      error: onFailureCallback,
      contentType: contentType,
      crossOrigin: isCrossOriginRequest,
      headers: headers,
    });
  },

  /**
   * Method takes a number like 1000000 and returns it separated hundreds by coma, like 1,000,000
   *
   * @param {number} number
   * @param {string} [countryFormat="en-GB"]
   * @returns {string}
   */
  formatCountNumber: function (number, countryFormat) {
    if (typeof countryFormat === 'undefined') {
      countryFormat = '';
    }

    var delimiter;

    switch (countryFormat) {
      case 'en-GB':
        delimiter = ',';
        break;
      default:
        delimiter = '.';
    }

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
  },

  /**
   * Takes a cookie name and returns its value (or undefined if no present)
   * @param {string} cookieName
   * @returns {string}
   */
  getCookieValue: function (cookieName) {
    var cookieTokens = new RegExp('(?:^|; )' + cookieName + '=([^;]*)').exec(
      document.cookie
    );
    return cookieTokens && cookieTokens.length > 0
      ? cookieTokens[1]
      : undefined;
  },

  /**
   * Takes a domain name and returns the naked domain (main name plus TLD)
   * @param {string} any given domain
   * @returns {string}
   */
  getNakedDomain: function (domain) {
    var domainTokens = domain.split('.');
    return domainTokens.length < 2
      ? domain
      : domainTokens.splice(domainTokens.length - 2).join('.');
  },

  /**
   * Takes a form element and generates a query string out of its elements, excluding those
   * with an empty value and those whose type is file, reset, submit, button...
   * @param form a dom element that contains a form
   * @returns an equivalent query string (without preceding "?")
   */
  formToQueryString: function (form) {
    return [].filter
      .call(form.elements, function (field) {
        return (
          field.name &&
          !field.disabled &&
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) === -1
        );
      })
      .map(function (field) {
        if (field.type === 'select-multiple') {
          return [].filter
            .call(field.options, function (option) {
              return option.selected;
            })
            .map(function (selectedOption) {
              return { name: field.name, value: selectedOption.value };
            });
        } else if (
          (field.type !== 'checkbox' && field.type !== 'radio') ||
          field.checked
        ) {
          return { name: field.name, value: field.value };
        }
      })
      .filter(function (nameAndValue) {
        return nameAndValue.value;
      })
      .map(function (nameAndValue) {
        return nameAndValue.name + '=' + encodeURIComponent(nameAndValue.value);
      })
      .join('&');
  },

  /**
   * Finds the first element in the array for which the predicate returns true, or undefined if none did
   * (replaces native Array#find which is not supported by all browsers)
   * @param array an array
   * @param predicate a binary function to compare elements against
   */
  findElement: function (array, predicate) {
    for (var i = 0; i < array.length; i++) {
      if (predicate(array[i])) {
        return array[i];
      }
    }
    return undefined;
  },

  /**
   * Does a query selector all but returns an array
   */
  querySelectorAll: function (parent, query) {
    return Array.prototype.slice.call(parent.querySelectorAll(query));
  },

  /**
   * Dispatch a custom event
   */
  dispatchCustomEvent: function (eventName) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, null);
    document.dispatchEvent(event);
  },

  /**
   * Replacement for Element.matches, which does not work in PhantomJS :/
   */
  matches: function (element, selector) {
    var p = Element.prototype;
    var f =
      p.matches ||
      p.webkitMatchesSelector ||
      p.mozMatchesSelector ||
      p.msMatchesSelector ||
      function (s) {
        return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
      };
    return f.call(element, selector);
  },

  /**
   * Null / undefined safe getter
   */
  getOrElse: function (object, field, defaultValue) {
    return object === undefined || object === null
      ? defaultValue
      : object[field];
  },
};
